export default {"src":"/_next/static/media/link.8434004f.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};